enum UserEvents {
    // ログインユーザー情報取得
    LoginStarted = "[User] LoginStarted",
    LoginComplete = "[User] LoginComplete",
    LoginFailed = "[User] LoginFailed",
    SessionTimeout = "[User] SessionTimeout",
    
    //ユーザー一覧取得
    GetUserInfoListStarted = "[User] GetUserInfoListStarted",
    GetUserInfoListComplete = "[User] GetUserInfoListComplete",
    // ユーザ一覧更新
    UpdateUserInfoStarted = "[User] UpdateUserInfoStarted",
    UpdateUserInfoComplete = "[User] UpdateUserInfoComplete",
    UpdateUserInfoFailed = "[User] UpdateUserInfoFailed",

    // ユーザ一プロファイル画像更新
    UpdateUserProfileImageStarted = "[User] UpdateUserProfileImageStarted",
    UpdateUserProfileImageComplete = "[User] UpdateUserProfileImageComplete",
    // 新規スキル作成
    CreateNewSkillStarted = "[User] CreateNewSkillStarted",
    CreateNewSkillCompleted = "[User] CreateNewSkillCompleted",
    CreateNewSkillFailed = "[User] CreateNewSkillFailed",
    ResetDuplicateSkillError = "[User] ResetDuplicateSkillError",
    // スキル一覧更新
    GetSkillListStarted = "[User] GetSkillListStarted",
    GetSkillListComplete = "[User] GetSkillListComplete",

    // ユーザー情報同期バッチを実行
    StartSyncBatch = "[User] StartSyncBatch",
    StartSyncBatchComplete = "[User] StartSyncBatchComplete",
    StartSyncBatchFailed = "[User] StartSyncBatchFailed",

    // ユーザーグループ情報を取得
    GetGroupListStart = "[User] GetGroupListStart",
    GetGroupListComplete = "[User] GetGroupListComplete",
    // ユーザーグループ情報を更新
    UpdateGroupListStart = "[User] UpdateGroupListStart",
    UpdateGroupListComplete = "[User] UpdateGroupListComplete",
    // アクセス可能なメールドメインのリストを取得
    GetAccessableEmailDomainListStart = "[User] GetAccessableEmailDomainListStart",
    GetAccessableEmailDomainListComplete = "[User] GetAccessableEmailDomainListComplete",
    // アクセス可能なメールドメインの更新
    UpdateAccessableEmailDomainListStart = "[User] UpdateAccessableEmailDomainListStart",
    UpdateAccessableEmailDomainListComplete = "[User] UpdateAccessableEmailDomainListComplete",
    // アクセス可能なユーザEMAILリストを取得
    GetAccessableEmailListStart = "[User] GetAccessableEmailListStart",
    GetAccessableEmailListComplete = "[User] GetAccessableEmailListComplete",
    // アクセス可能なユーザEMAILの更新
    UpdateAccessableEmailListStart = "[User] UpdateAccessableEmailListStart",
    UpdateAccessableEmailListComplete = "[User] UpdateAccessableEmailListComplete",

    // ユーザーライセンス情報を取得
    GetUserLicenseStart = "[User] GetUserLicenseStart ",
    GetUserLicenseComplete = "[User] GetUserLicenseComplete",
}
export default UserEvents;
